import { isBoardingProcessingStatue } from "@/types/employeeState";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "../store";

const PublicRoute = (): JSX.Element => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const search = useLocation().search;
  const rawParams = new URLSearchParams(search);
  rawParams.delete("code"); // Don't forward invitation codes — contain sensitive credential data
  const searchParams = rawParams.toString();
  const isAuthenticated = (): boolean => !!user.id;

  const isLegalPage = (): boolean => {
    const currentPath = location.pathname;
    return currentPath.includes("/help");
  };

  if (isAuthenticated() && !isLegalPage()) {
    if (user.IsDefaultPasswordChanged === "True") {
      if (isBoardingProcessingStatue(user.onboardingProgress)) {
        return (
          <Navigate
            to={`/?${searchParams}`}
            state={{ from: location }}
            replace
          />
        );
      } else {
        return (
          <Navigate
            to={`/wizard?${searchParams}`}
            state={{ from: location }}
            replace
          />
        );
      }
    }
  }

  return <Outlet />;
};

export default PublicRoute;
